<template>
  <div v-if="relatives">
    <div v-if="data">
      <Top />
      <div class="container">
        <div class="row">
          <div class="col-sm" :class="{ 'order-2': isPhoneMediaQuery }">
            <div class="clearfix m-b-100" v-if="!isPhoneMediaQuery"></div>
            <p class="text-left border--emphasize">
              Tidigare släkting? Ta del av din information
              <strong><a href="" data-toggle="modal" data-target="#relativeModal">här</a></strong>.
            </p>
          </div>
          <div class="col-md-6" :class="{ 'order-1': isPhoneMediaQuery }">
            <div class="clearfix"></div>
            <img src="@/assets/img/heart.svg?data" alt="Ett FH hjärta" class="img-fluid" />
            <div class="clearfix"></div>
            <div class="header-wrapper">
              <div class="clearfix"></div>
              <h4 class="text-primary-fh welcome-header-h4" v-html="data.familytreedashboard.welcomeHeader"></h4>
              <h4 class="text-primary-fh welcome-header-h4">{{ toTitleCase(fullname) }}!</h4>
            </div>
            <p v-html="data.familytreedashboard.infoText"></p>
            <div class="justify-content-center">
              Efter att du fyllt i någon släkting så skickar du meddelande
              <span class="text-primary-fh text-center cursor" @click="goToMessageBtn()"><b>här</b></span>.
            </div>
            <div class="clearfix"></div>
            <label for="progress" class="text-primary-fh larger-text" v-if="finishedSections === getRelationshipSections">
              <strong>
                Alla släktgrenar ifyllda!
              </strong>
            </label>
            <label for="progress" class="text-primary-fh" v-if="finishedSections !== getRelationshipSections">
              <strong>
                <span v-text="finishedSections"></span> av
                <span v-text="getRelationshipSections"></span> valfria sektioner ifyllda
              </strong>
            </label>
            <div class="progress">
              <div class="progress-bar" :style="{ width: ((finishedSections / getRelationshipSections) * 100) + '%' }"
                role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">
              </div>
            </div>
            <p v-html="data.familytreedashboard.infoDisclaimer"></p>
          </div>
          <div class="col-sm" :class="{ 'order-3': isPhoneMediaQuery }">
            <div v-if="childrenUnder13TestResults && childrenUnder13TestResults.length > 0">
              <div class="clearfix m-b-100"></div>
              <h5 class="text-primary-fh text-left"><strong>För dig med barn &#60;13 år.</strong></h5>
              <p>Välj barn för att se information och ta del av ditt barns resultat</p>
              <select class="form-control" @change="routeToDashboardMinor($event)">
                <option :value="0">- Välj minderårigt barn -</option>
                <option v-for="(child, i) in childrenUnder13TestResults" :value="child.personId" v-bind:key="i">
                  {{ child.firstName + ' ' + child.lastName }}
                </option>
              </select>
            </div>
            <div v-if="childrenUnder13 && childrenUnder13.length > 0">
              <div class="clearfix m-b-100"></div>
              <h5 class="text-primary-fh text-left" v-if="!hasConsentToBeGivenBelow13">
                Du har gett samtycke åt samtliga barn under (&#60;13 år) ✓
              </h5>
              <h5 class="text-danger text-left" v-if="hasConsentToBeGivenBelow13">
                <strong>Du behöver ge samtycke åt dina barn (&#60;13 år)</strong>
              </h5>
              <small class="text-consent-choices" v-if="!hasConsentToBeGivenBelow13">
                I listan nedan ser du vilka samtyckesval du gjort.
              </small>
              <small class="text--consent--choices" v-if="hasConsentToBeGivenBelow13">
                I listan nedan ser du vilka barn som är i behov av din uppmärksamhet. <br/>
                Är ett barn markerat med <span class="text-danger">röd text</span> så återstår ett eller fler samtycke. <br/>
                Är ett barn markerat med <span class="text-success">grön text</span> så är båda samtycken utförda.
              </small>
              <select class="form-control" @change="routeToConsentMinor($event)">
                <option :value="0">- Välj barn -</option>
                <option v-for="(child, i) in childrenUnder13" :value="child.personId" v-bind:key="i"
                  :class="[getConsentStatus(child) === 'consent-to-give-finished' ? 'text-success' : '',
                  getConsentStatus(child) === 'consent-to-give-remains' ? 'text-danger' : '']">
                    {{ child.firstName + ' ' + child.lastName }}
                </option>
              </select>
            </div>
            <div v-if="childrenBetween13And15 && childrenBetween13And15.length > 0">
              <div class="clearfix m-b-100"></div>
              <h5 class="text-primary-fh text-left" v-if="!hasConsentToBeGivenAbove13">
                Du har gett samtycke åt samtliga barn (13-15 år) ✓
              </h5>
              <h5 class="text-danger text-left" v-if="hasConsentToBeGivenAbove13">
                <strong>Du behöver ge samtycke åt dina barn (13-15 år)</strong>
              </h5>
              <small class="text-consent-choices" v-if="!hasConsentToBeGivenAbove13">
                I listan nedan ser du vilka samtyckesval du gjort.
              </small>
              <small class="text--consent--choices" v-if="hasConsentToBeGivenAbove13">
                I listan nedan ser du vilka barn som är i behov av din uppmärksamhet. <br/>
                Är ett barn markerat med <span class="text-danger">röd text</span> så behövs samtycke. <br/>
                Är ett barn markerat med <span class="text-success">grön text</span> så är samtycke utfört.
              </small>
              <select class="form-control" @change="routeToConsentMinor($event)">
                <option :value="0">- Välj barn -</option>
                <option v-for="(child, i) in childrenBetween13And15" :value="child.personId" v-bind:key="i"
                  :class="[getConsentStatus(child) === 'consent-to-give-finished' ? 'text-success' : '',
                  getConsentStatus(child) === 'consent-to-give-remains' ? 'text-danger' : '']">
                    {{ child.firstName + ' ' + child.lastName }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm"></div>
          <div class="col-md-6">
            <!-- Föräldrar -->
            <div class="card">
              <div class="card-body">
                <h5 class="card-title text-primary-fh text-left" v-html="data.familytreedashboard.parentsHeader"></h5>
                <router-link v-if="relativesBySection('parents').length > 0" :to="{ name: 'ftchange', params: { type: relationships.parents } }"
                    class="btn btn-primary change-btn btn-sm">
                  Ändra
                </router-link>
                <router-link v-if="relativesBySection('parents').length === 0" :to="{ name: 'ftbuild', params: { type: relationships.parents } }"
                  class="btn btn-primary btn-block btn-lg fill-in-btn">
                  Fyll i
                </router-link>
                <div class="row">
                  <div v-for="(relative, i) in relativesBySection('parents')" v-bind:key="i" class="col-lg-6">
                    <div class="text-left" v-if="relativesBySection('parents').length > 0">
                      <h6 class="text-muted" v-text="kinshipType(relative.familyRelation)"></h6>
                      <h6 class="text-muted smaller-h6" v-if="relative.familyTreeParentNode !== null"
                        v-text="getParentNodeName(relative.familyTreeParentNode)"></h6>
                      <strong class="text-dark"
                        v-text="relative.firstName + ' ' + relative.lastName" v-if="!hasAcceptedInvite(relative) && !hasPassedAway(relative)"></strong>
                      <strong class="text-success text--relative"
                        v-text="relative.firstName + ' ' + relative.lastName" v-if="hasAcceptedInvite(relative) && !hasPassedAway(relative)"></strong>
                      <strong class="text dark passed-away" v-text="relative.firstName + ' ' + relative.lastName" v-if="hasPassedAway(relative)"></strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Barn -->
            <div class="card">
              <div class="card-body">
                <h5 class="card-title text-primary-fh text-left" v-html="data.familytreedashboard.childrenHeader"></h5>
                <router-link v-if="relativesBySection('children').length > 0 || nochildren" :to="{ name: 'ftchange', params: { type: relationships.children } }"
                    class="btn btn-primary change-btn btn-sm">
                  Ändra
                </router-link>
                <router-link v-if="relativesBySection('children').length === 0 && !nochildren" :to="{ name: 'ftbuild', params: { type: relationships.children } }"
                  class="btn btn-primary btn-block btn-lg fill-in-btn">
                  Fyll i
                </router-link>
                <p class="text-muted" v-if="nochildren"><i>Inga barn</i></p>
                <div class="row">
                  <div v-for="(relative, i) in relativesBySection('children')" v-bind:key="i" class="col-lg-6">
                    <div class="text-left" v-if="relativesBySection('children').length > 0">
                      <h6 class="text-muted" v-text="kinshipType(relative.familyRelation)"></h6>
                      <h6 class="text-muted smaller-h6" v-if="relative.familyTreeParentNode !== null"
                        v-text="getParentNodeName(relative.familyTreeParentNode)"></h6>
                      <strong class="text-dark"
                        v-text="relative.firstName + ' ' + relative.lastName" v-if="!hasAcceptedInvite(relative) && !hasPassedAway(relative)"></strong>
                      <strong class="text-success text--relative"
                        v-text="relative.firstName + ' ' + relative.lastName" v-if="hasAcceptedInvite(relative) && !hasPassedAway(relative)"></strong>
                      <strong class="text dark passed-away" v-text="relative.firstName + ' ' + relative.lastName" v-if="hasPassedAway(relative)"></strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card hasChildrenUnder13-card" v-if="childrenUnder13State && childrenUnder13Consent === true">
              <div class="card-body">
                <small class="hasChildrenUnder13-small">
                Har barn &#60;13 år och gett samtycke till
                att bli kontaktad av person inom vården för screening av barn. ✓
                </small>
              </div>
            </div>
            <div class="card hasChildrenUnder13-card" v-if="childrenUnder13State && childrenUnder13Consent === false">
              <div class="card-body">
                <small class="hasChildrenUnder13-small">
                Har barn &#60;13 år (ej lämnat samtycke till screening av barn)
                </small>
              </div>
            </div>
            <!-- Syskon -->
            <div class="card">
              <div class="card-body">
                <h5 class="card-title text-primary-fh text-left" v-html="data.familytreedashboard.siblingsHeader"></h5>
                <router-link v-if="relativesBySection('siblings').length > 0 || nosiblings"
                    :to="{ name: 'ftchange', params: { type: relationships.siblings } }" class="btn btn-primary change-btn btn-sm">
                  Ändra
                </router-link>
                <router-link v-if="relativesBySection('siblings').length === 0 && !nosiblings"
                    :to="{ name: 'ftbuild', params: { type: relationships.siblings } }" class="btn btn-primary btn-block btn-lg fill-in-btn">
                  Fyll i
                </router-link>
                <p class="text-muted" v-if="nosiblings"><i>Inga syskon</i></p>
                <div class="row">
                  <div v-for="(relative, i) in relativesBySection('siblings')" v-bind:key="i" class="col-lg-6">
                    <div class="text-left" v-if="relativesBySection('siblings').length > 0">
                      <h6 class="text-muted" v-text="kinshipType(relative.familyRelation)"></h6>
                      <h6 class="text-muted smaller-h6" v-if="relative.familyTreeParentNode !== null"
                        v-text="getParentNodeName(relative.familyTreeParentNode)"></h6>
                      <strong class="text-dark"
                        v-text="relative.firstName + ' ' + relative.lastName" v-if="!hasAcceptedInvite(relative) && !hasPassedAway(relative)"></strong>
                      <strong class="text-success text--relative"
                        v-text="relative.firstName + ' ' + relative.lastName" v-if="hasAcceptedInvite(relative) && !hasPassedAway(relative)"></strong>
                      <strong class="text dark passed-away" v-text="relative.firstName + ' ' + relative.lastName" v-if="hasPassedAway(relative)"></strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Halvsyskon på mammas sida -->
            <div class="card">
              <div class="card-body">
                <h5 class="card-title text-primary-fh text-left" v-html="data.familytreedashboard.motherhalfsiblingsHeader"></h5>
                <router-link v-if="relativesBySection('motherhalfsiblings').length > 0 || nomotherhalfsiblings"
                    :to="{ name: 'ftchange', params: { type: relationships.motherhalfsiblings } }" class="btn btn-primary change-btn btn-sm">
                  Ändra
                </router-link>
                <router-link v-if="relativesBySection('motherhalfsiblings').length === 0 && !nomotherhalfsiblings"
                    :to="{ name: 'ftbuild', params: { type: relationships.motherhalfsiblings } }" class="btn btn-primary btn-block btn-lg fill-in-btn">
                  Fyll i
                </router-link>
                <p class="text-muted" v-if="nomotherhalfsiblings"><i>Inga halvsyskon på mammas sida</i></p>
                <div class="row">
                  <div v-for="(relative, i) in relativesBySection('motherhalfsiblings')" v-bind:key="i" class="col-lg-6">
                    <div class="text-left" v-if="relativesBySection('motherhalfsiblings').length > 0">
                      <h6 class="text-muted" v-text="kinshipType(relative.familyRelation)"></h6>
                      <h6 class="text-muted smaller-h6" v-if="relative.familyTreeParentNode !== null"
                        v-text="getParentNodeName(relative.familyTreeParentNode)"></h6>
                      <strong class="text-dark"
                        v-text="relative.firstName + ' ' + relative.lastName" v-if="!hasAcceptedInvite(relative) && !hasPassedAway(relative)"></strong>
                      <strong class="text-success text--relative"
                        v-text="relative.firstName + ' ' + relative.lastName" v-if="hasAcceptedInvite(relative) && !hasPassedAway(relative)"></strong>
                      <strong class="text dark passed-away" v-text="relative.firstName + ' ' + relative.lastName" v-if="hasPassedAway(relative)"></strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Halvsyskon på pappas sida -->
            <div class="card">
              <div class="card-body">
                <h5 class="card-title text-primary-fh text-left" v-html="data.familytreedashboard.fatherhalfsiblingsHeader"></h5>
                <router-link v-if="relativesBySection('fatherhalfsiblings').length > 0 || nofatherhalfsiblings"
                    :to="{ name: 'ftchange', params: { type: relationships.fatherhalfsiblings } }" class="btn btn-primary change-btn btn-sm">
                  Ändra
                </router-link>
                <router-link v-if="relativesBySection('fatherhalfsiblings').length === 0 && !nofatherhalfsiblings"
                    :to="{ name: 'ftbuild', params: { type: relationships.fatherhalfsiblings } }" class="btn btn-primary btn-block btn-lg fill-in-btn">
                  Fyll i
                </router-link>
                <p class="text-muted" v-if="nofatherhalfsiblings"><i>Inga halvsyskon på pappas sida</i></p>
                <div class="row">
                  <div v-for="(relative, i) in relativesBySection('fatherhalfsiblings')" v-bind:key="i" class="col-lg-6">
                    <div class="text-left" v-if="relativesBySection('fatherhalfsiblings').length > 0">
                      <h6 class="text-muted" v-text="kinshipType(relative.familyRelation)"></h6>
                      <h6 class="text-muted smaller-h6" v-if="relative.familyTreeParentNode !== null"
                        v-text="getParentNodeName(relative.familyTreeParentNode)"></h6>
                      <strong class="text-dark"
                        v-text="relative.firstName + ' ' + relative.lastName" v-if="!hasAcceptedInvite(relative) && !hasPassedAway(relative)"></strong>
                      <strong class="text-success text--relative"
                        v-text="relative.firstName + ' ' + relative.lastName" v-if="hasAcceptedInvite(relative) && !hasPassedAway(relative)"></strong>
                      <strong class="text dark passed-away" v-text="relative.firstName + ' ' + relative.lastName" v-if="hasPassedAway(relative)"></strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Kusiner på mammas sida -->
            <div class="card">
              <div class="card-body">
                <h5 class="card-title text-primary-fh text-left" v-html="data.familytreedashboard.mothercousinsHeader"></h5>
                <router-link v-if="relativesBySection('mothercousins').length > 0 || nomothercousins"
                    :to="{ name: 'ftchange', params: { type: relationships.mothercousins } }" class="btn btn-primary change-btn btn-sm">
                  Ändra
                </router-link>
                <router-link v-if="relativesBySection('mothercousins').length === 0 && !nomothercousins"
                    :to="{ name: 'ftbuild', params: { type: relationships.mothercousins } }" class="btn btn-primary btn-block btn-lg fill-in-btn">
                  Fyll i
                </router-link>
                <p class="text-muted" v-if="nomothercousins"><i>Inga syskon samt kusiner på mammas sida</i></p>
                <div class="row">
                  <div v-for="(relative, i) in relativesBySection('mothercousins')" v-bind:key="i" class="col-lg-6">
                    <div class="text-left" v-if="relativesBySection('mothercousins').length > 0">
                      <h6 class="text-muted" v-text="kinshipType(relative.familyRelation)"></h6>
                      <h6 class="text-muted smaller-h6" v-if="relative.familyTreeParentNode !== null"
                        v-text="getParentNodeName(relative.familyTreeParentNode)"></h6>
                      <strong class="text-dark"
                        v-text="relative.firstName + ' ' + relative.lastName" v-if="!hasAcceptedInvite(relative) && !hasPassedAway(relative)"></strong>
                      <strong class="text-success text--relative"
                        v-text="relative.firstName + ' ' + relative.lastName" v-if="hasAcceptedInvite(relative) && !hasPassedAway(relative)"></strong>
                      <strong class="text dark passed-away" v-text="relative.firstName + ' ' + relative.lastName" v-if="hasPassedAway(relative)"></strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Kusiner på pappas sida -->
            <div class="card">
              <div class="card-body">
                <h5 class="card-title text-primary-fh text-left" v-html="data.familytreedashboard.fathercousinsHeader"></h5>
                <router-link v-if="relativesBySection('fathercousins').length > 0 || nofathercousins"
                    :to="{ name: 'ftchange', params: { type: relationships.fathercousins } }" class="btn btn-primary change-btn btn-sm">
                  Ändra
                </router-link>
                <router-link v-if="relativesBySection('fathercousins').length === 0 && !nofathercousins"
                    :to="{ name: 'ftbuild', params: { type: relationships.fathercousins } }" class="btn btn-primary btn-block btn-lg fill-in-btn">
                  Fyll i
                </router-link>
                <p class="text-muted" v-if="nofathercousins"><i>Inga syskon samt kusiner på pappas sida</i></p>
                <div class="row">
                  <div v-for="(relative, i) in relativesBySection('fathercousins')" v-bind:key="i" class="col-lg-6">
                    <div class="text-left" v-if="relativesBySection('fathercousins').length > 0">
                      <h6 class="text-muted" v-text="kinshipType(relative.familyRelation)"></h6>
                      <h6 class="text-muted smaller-h6" v-if="relative.familyTreeParentNode !== null"
                        v-text="getParentNodeName(relative.familyTreeParentNode)"></h6>
                      <strong class="text-dark"
                        v-text="relative.firstName + ' ' + relative.lastName" v-if="!hasAcceptedInvite(relative) && !hasPassedAway(relative)"></strong>
                      <strong class="text-success text--relative"
                        v-text="relative.firstName + ' ' + relative.lastName" v-if="hasAcceptedInvite(relative) && !hasPassedAway(relative)"></strong>
                      <strong class="text dark passed-away" v-text="relative.firstName + ' ' + relative.lastName" v-if="hasPassedAway(relative)"></strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm"></div>
        </div>
        <div class="row">
          <div class="col-sm"></div>
          <div id="col-invite-disclaimer" class="col-md-6">
            <div class="clearfix"></div>
            <br />
            <h4 class="text-primary-fh" v-html="data.familytreedashboard.inviterelativesheader" v-if="finishedSections === 0"></h4>
            <label for="progress" class="text-primary-fh" v-if="numberOfRelativesInvited !== relatives.length">
              <strong>
                <span v-text="numberOfRelativesInvited"></span> av
                <span v-text="relatives.length"></span> släktingar inbjudna
              </strong>
            </label>
            <label for="progress" class="text-primary-fh" v-if="relatives.length !== 0 && numberOfRelativesInvited === relatives.length">
              <strong class="larger-text">
                Alla släktingar inbjudna!
              </strong>
            </label>
            <div class="progress">
              <div class="progress-bar" :style="{ width: ((numberOfRelativesInvited / relatives.length) * 100) + '%' }"
                role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">
              </div>
            </div>
            <p v-if="finishedSections === 0" v-html="data.familytreedashboard.inviterelativesemptytext"></p>
            <p v-if="finishedSections !== 0" v-html="data.familytreedashboard.inviterelativestext"></p>
            <div class="clearfix"></div>
            <router-link
              v-if="finishedSections !== 0"
              to="/invite"
              class="btn btn-primary btn-block btn-lg">
              {{ data.familytree.newinviteHeader }}
            </router-link>
            <div class="clearfix"></div>
          </div>
          <div class="col-sm"></div>
        </div>
      </div>
    <!-- Previous relative modal -->
    <div v-if="data" class="modal fade wrapper-margin-top"
      id="relativeModal" role="dialog" aria-labelledby="relativeModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="relativeModalLabel" v-if="prevRelativeData">
              Din tidigare släktinginformation
            </h5>
            <button type="button" class="close" title="Logga ut" data-dismiss="modal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="register-card" v-if="prevRelativeData.length === 0">
              <div class="card-body">
                Vänligen vänta medan data laddas..
              </div>
            </div>
            <div class="register-card" v-if="prevRelativeData && prevRelativeData.length > 0">
              <div id="prevRelativeData" class="card-body w-break">
                  <div v-if="prevRelativeData[0]">
                    <div v-if="prevRelativeData[0].patientText">
                      <h5 class="text-left font-weight-bold">Blodprovsbedömning:</h5>
                      <p>{{ prevRelativeData[0].patientText }}</p>
                      <hr />
                    </div>
                  </div>
                  <div v-if="prevRelativeData[1] && !isGeneNegative">
                    <h5 class="text-left font-weight-bold">Genetiskt test:</h5>
                    <p v-if="prevRelativeData[1].diagnosisDate">
                      {{ prevRelativeData[1].diagnosisDate.substring(0, 10) }}
                    </p>
                    <p>{{ prevRelativeData[1].diagnosisLocation }}</p>
                    <p>{{ prevRelativeData[1].mutation }}</p>
                    <p>{{ prevRelativeData[1].mutationLong }}</p>
                    <hr />
                  </div>
                  <div v-if="prevRelativeData[2]">
                    <div v-if="prevRelativeData[2].patientText">
                      <h5 class="text-left font-weight-bold">Beslut:</h5>
                      <p>{{ prevRelativeData[2].patientText }}</p>
                      <hr />
                    </div>
                  </div>
                  <div v-if="prevRelativeData[3]">
                    <div v-if="prevRelativeData[3].decisionText">
                      <h5 class="text-left font-weight-bold">Beslut (kardiologpatient):</h5>
                      <p>{{ prevRelativeData[3].decisionText }}</p>
                      <hr />
                    </div>
                  </div>
                  <div v-if="prevRelativeData[4] && prevRelativeData[4].length > 0">
                    <h5 class="text-left font-weight-bold">Dina svar på screeningfrågor:</h5>
                    <div v-for="(scr, i) in prevRelativeData[4]" :key="i">
                      <p>
                        {{ scr.question }}
                        <br />
                        ➢ {{ scr.answer }}
                        <span v-if="scr.eggs">{{ scr.eggs.answer }}</span>
                      </p>
                    </div>
                  </div>
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">Stäng</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
    <Bottom />
    </div>
    <vue-cookie-accept-decline
      :ref="'cookies'"
      :elementId="'cookies'"
      :debug="false"
      :position="'bottom-left'"
      :type="'floating'"
      :disableDecline="true"
      :transitionName="'slideFromBottom'"
      :showPostponeButton="false">
      <div slot="message">
        Denna sida använder cookies. <br />
        Läs mer <a href="https://www.pts.se/cookies" target="_blank">här</a>.
      </div>
      <div slot="acceptContent">Jag förstår</div>
    </vue-cookie-accept-decline>
  </div>
</template>

<script>
import Top from '../../src/components/Top'
import Bottom from '../../src/components/Bottom'
import { request } from '../plugins/datocms'
import { getKinshipType } from '../plugins/relationhandler'
import config from '../../config/index.js'
import axios from '../plugins/axios'

export default {
  name: 'familytree',
  components: {
    Top,
    Bottom
  },
  data () {
    return {
      data: null,
      isPhoneMediaQuery: false,
      fullname: '',
      childrenUnder13Consent: null,
      childrenUnder13State: null,
      childrenUnder13TestResults: null,
      childrenBetween13And15: null,
      childrenUnder13: null,
      prevRelativeData: [],
      relationships: {
        parents: 'parents',
        parentsEnum: [1, 2, 3, 4, 5, 6],
        children: 'children',
        childrenEnum: [7, 8],
        siblings: 'siblings',
        siblingsEnum: [9, 10],
        motherhalfsiblings: 'motherhalfsiblings',
        motherhalfsiblingsEnum: [11, 12],
        fatherhalfsiblings: 'fatherhalfsiblings',
        fatherhalfsiblingsEnum: [13, 14],
        mothercousins: 'mothercousins',
        mothercousinsEnum: [15, 17],
        fathercousins: 'fathercousins',
        fathercousinsEnum: [16, 18]
      },
      noparents: sessionStorage.getItem('noparents') === 'true' || false,
      nochildren: sessionStorage.getItem('nochildren') === 'true' || false,
      nosiblings: sessionStorage.getItem('nosiblings') === 'true' || false,
      nomotherhalfsiblings: sessionStorage.getItem('nomotherhalfsiblings') === 'true' || false,
      nofatherhalfsiblings: sessionStorage.getItem('nofatherhalfsiblings') === 'true' || false,
      nomothercousins: sessionStorage.getItem('nomothercousins') === 'true' || false,
      nofathercousins: sessionStorage.getItem('nofathercousins') === 'true' || false,
      isGeneNegative: sessionStorage.getItem('isGeneNegative') === 'true' || false,
      relatives: []
    }
  },
  methods: {
    routeToDashboardMinor (event) {
      if (event && event.target.value !== '0') {
        window.location.href = window.location.origin + '/dashboardminor/' + parseInt(event.target.value)
      }
    },
    routeToConsentMinor (event) {
      if (event && event.target.value !== '0') {
        window.location.href = window.location.origin + '/consentminor/' + parseInt(event.target.value)
      }
    },
    toTitleCase (phrase) {
      if (phrase) {
        return phrase
          .toLowerCase()
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
      }
    },
    goToMessageBtn () {
      const disclaimer = document.getElementById('col-invite-disclaimer')
      disclaimer.scrollIntoView({behavior: 'smooth', block: 'center'})
    },
    kinshipType (famRel) {
      const result = getKinshipType(famRel)
      return result
    },
    getParentNodeName (node) {
      let result = ''
      this.relatives.forEach(relative => {
        if (node === relative.familyTreeNode) {
          result = '(Tillhör: ' + relative.firstName + ' ' + relative.lastName + ')'
        }
      })
      return result
    },
    relativesBySection (type) {
      const result = []
      if (this.relatives.length > 0) {
        this.relatives.forEach(relative => {
          if (type === 'parents' && this.relationships.parentsEnum
            .includes(relative.familyRelation)) {
            result.push(relative)
          }
          if (type === 'children' && this.relationships.childrenEnum
            .includes(relative.familyRelation)) {
            result.push(relative)
          }
          if (type === 'grandchildren' && this.relationships.childrenEnum
            .includes(relative.familyRelation)) {
            result.push(relative)
          }
          if (type === 'siblings' && this.relationships.siblingsEnum
            .includes(relative.familyRelation)) {
            result.push(relative)
          }
          if (type === 'siblingschildren' && this.relationships.siblingsEnum
            .includes(relative.familyRelation)) {
            result.push(relative)
          }
          if (type === 'motherhalfsiblings' && this.relationships.motherhalfsiblingsEnum
            .includes(relative.familyRelation)) {
            result.push(relative)
          }
          if (type === 'fatherhalfsiblings' && this.relationships.fatherhalfsiblingsEnum
            .includes(relative.familyRelation)) {
            result.push(relative)
          }
          if (type === 'mothercousins' && this.relationships.mothercousinsEnum
            .includes(relative.familyRelation)) {
            result.push(relative)
          }
          if (type === 'fathercousins' && this.relationships.fathercousinsEnum
            .includes(relative.familyRelation)) {
            result.push(relative)
          }
        })
      }
      return result
    },
    hasAcceptedInvite (relative) {
      if (relative) {
        if (relative.invitationStatus === 'Inbjuden' ||
          relative.invitationStatus === 'Accepterat' ||
          relative.invitationStatus === 'Avböjt') {
          return true
        } else {
          return false
        }
      }
    },
    hasPassedAway (relative) {
      if (relative) {
        if (relative.alive === false) {
          return true
        }
        return false
      }
    },
    getConsentStatus (c) {
      if (c) {
        // If minor child (<13), check both consents - otherwise consent for research is viable (13-15)
        if ((c.below13 && c.consentScreening === null) || c.consentResearch === null) {
          return 'consent-to-give-remains'
        } else {
          return 'consent-to-give-finished'
        }
      }
      return ''
    },
    async getChildrenUnder13Consent () {
      axios._get(config.childrenUnder13Uri + config.consentUri).then(response => {
        this.childrenUnder13Consent = response.data.consent
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        }
      })
    },
    async getChildrenUnder13State () {
      axios._get(config.childrenUnder13Uri).then(response => {
        this.childrenUnder13State = response.data.hasChildrenUnder13
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get state: ' + error)
        }
      })
    },
    async getChildrenUnder13TestResults () {
      axios._get(config.childrenUnder13Uri + config.testresultsUri).then(response => {
        this.childrenUnder13TestResults = response.data.childrenWithTestResults
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get children with testresults: ' + error)
        }
      })
    },
    async getChildrenUnder13 () {
      axios._get(config.childrenUnder13Uri + config.allChildrenUri).then(response => {
        this.childrenUnder13 = response.data.childrenConsents
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get children consents: ' + error)
        }
      })
    },
    async getChildrenBetween13And15ConsentResearch () {
      axios._get(config.childrenbetween13and15Uri + config.consentResearchUri).then(response => {
        this.childrenBetween13And15 = response.data.childrenConsents
        /* First get personIds, then filter out duplicates but keep one of them so not both get removed */
        this.childrenBetween13And15 = this.childrenBetween13And15
          .filter(({personId}, index) => !this.childrenBetween13And15
            .map(c => c.personId).includes(personId, index + 1))
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get children age span 13-15 with need of consent: ' + error)
        }
      })
    },
    async getRelatives () {
      let loader = this.$loading.show()
      axios._get(config.relativeUri).then(response => {
        this.relatives = response.data.relatives
        loader.hide()
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          loader.hide()
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get relatives: ' + error)
          loader.hide()
        }
      })
    },
    async getPrevRelativeData () {
      if (this.prevRelativeData !== null) {
        axios._get(config.bloodtestUri).then(response => {
          if (response) {
            this.prevRelativeData.push(response.data.assessment)
            axios._get(config.gentestUri).then(response => {
              if (response) {
                this.prevRelativeData.push(response.data.geneticTestData)
                axios._get(config.diagnosisUri).then(response => {
                  if (response) {
                    this.prevRelativeData.push(response.data.fhDiagnosis)
                    axios._get(config.gentestUri + config.cardioDecisionUri).then(response => {
                      if (response) {
                        this.prevRelativeData.push(response.data.cardiologyGeneticTestReferral)
                        axios._get(config.screeningAnswerUri).then(response => {
                          if (response) {
                            const answers = []
                            response.data.answers.forEach(a => {
                              if (a) {
                                answers.push(JSON.parse(a.answer))
                              }
                            })
                            this.prevRelativeData.push(answers)
                          }
                        }).catch((error) => {
                          if (error.response && error.response.status === 401) {
                            window.location.href = window.location.origin.concat('/error')
                          } else {
                            console.log('Request went bad to screeninganswers: ' + error)
                          }
                        })
                      }
                    }).catch((error) => {
                      if (error.response && error.response.status === 401) {
                        window.location.href = window.location.origin.concat('/error')
                      } else {
                        console.log('Could not get cardio decision regarding genetictest: ' + error)
                      }
                    })
                  }
                }).catch((error) => {
                  if (error.response && error.response.status === 401) {
                    window.location.href = window.location.origin.concat('/error')
                  } else {
                    console.log('Could not get diagnosis: ' + error)
                  }
                })
              }
            }).catch((error) => {
              if (error.response && error.response.status === 401) {
                window.location.href = window.location.origin.concat('/error')
              } else {
                console.log('Could not get gentest: ' + error)
              }
            })
          }
        }).catch((error) => {
          if (error.response && error.response.status === 401) {
            window.location.href = window.location.origin.concat('/error')
          } else {
            console.log('Could not get bloodtest: ' + error)
          }
        })
      }
    }
  },
  computed: {
    hasConsentToBeGivenAbove13 () {
      // Return bool if any object in the list contains null of either screening or research consent
      if (this.childrenBetween13And15) {
        return this.childrenBetween13And15.some(c => (c.below13 && c.consentScreening === null) || c.consentResearch === null)
      }
    },
    hasConsentToBeGivenBelow13 () {
      // Return bool if any object in the list contains null of either screening or research consent
      if (this.childrenUnder13) {
        return this.childrenUnder13.some(c => (c.below13 && c.consentScreening === null) || c.consentResearch === null)
      }
    },
    getRelationshipSections () {
      // Divide by 2 - we only need the names, since they are the sections
      return Object.keys(this.relationships).length / 2
    },
    finishedSections () {
      if (this.relatives.length > 0) {
        const p = this.relatives.some(r => this.relationships.parentsEnum.includes(r.familyRelation))
        const c = this.relatives.some(r => this.relationships.childrenEnum.includes(r.familyRelation))
        const s = this.relatives.some(r => this.relationships.siblingsEnum.includes(r.familyRelation))
        const mhs = this.relatives.some(r => this.relationships.motherhalfsiblingsEnum.includes(r.familyRelation))
        const fhs = this.relatives.some(r => this.relationships.fatherhalfsiblingsEnum.includes(r.familyRelation))
        const mc = this.relatives.some(r => this.relationships.mothercousinsEnum.includes(r.familyRelation))
        const fc = this.relatives.some(r => this.relationships.fathercousinsEnum.includes(r.familyRelation))
        return [p, c, s, mhs, fhs, mc, fc,
          this.nochildren, this.nosiblings,
          this.nomotherhalfsiblings, this.nofatherhalfsiblings,
          this.nomothercousins, this.nofathercousins].filter(v => v).length
      } else {
        return 0
      }
    },
    numberOfRelativesInvited () {
      let invited = 0
      this.relatives.forEach(relative => {
        if (relative.invitationStatus === 'Inbjuden' ||
          relative.invitationStatus === 'Accepterat' ||
          relative.invitationStatus === 'Avböjt') {
          invited++
        }
      })
      return invited
    }
  },
  async beforeMount () {
    this.fullname = sessionStorage.getItem('fullname')
    await this.getRelatives()
    await this.getChildrenUnder13()
    await this.getChildrenUnder13Consent()
    await this.getChildrenUnder13TestResults()
    await this.getChildrenBetween13And15ConsentResearch()
    await this.getChildrenUnder13State()
    await this.getPrevRelativeData()
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          familytreedashboard {
            welcomeHeader
            infoText
            infoDisclaimer
            parentsHeader
            childrenHeader
            siblingsHeader
            motherhalfsiblingsHeader
            fatherhalfsiblingsHeader
            mothercousinsHeader
            fathercousinsHeader
            inviterelativesheader
            inviterelativestext
            inviterelativesemptytext
          }
          familytree {
            newinviteHeader
          }
        }
      `
    })
  },
  created () {
    var maxWidth = window.matchMedia('(max-width: 812px)')
    var minWidth = window.matchMedia('(min-width: 300px)')
    if (maxWidth.matches && minWidth.matches) {
      this.isPhoneMediaQuery = true
    } else {
      this.isPhoneMediaQuery = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h5 {
  font-size: 1rem;
}
h6 {
  font-size: 0.9rem;
  margin-bottom: 0;
}
hr {
  margin-bottom: 5px;
}
.container {
  margin-top: 25vh;
}
.header-wrapper {
  display: flex;
  justify-content: center;
}
.text-left {
  text-align: left;
}
.border--emphasize {
  border-left: 5px solid #069ccc;
  padding: 20px;
}
.cursor {
  cursor: pointer;
}
.card {
  border: 2px solid #bae2ef;
  border-radius: 15px;
  margin-top: 2rem;
}
.card strong {
  font-size: 0.8rem;
}
.card h6 {
  margin-top: 5px;
}
.card-body {
  background: #e5f1f5;
  border-radius: 15px;
}
.progress {
  margin-bottom: 15px;
}
.larger-text {
  font-size: 1.2em;
}
.smaller-h6 {
  font-size: 0.8em;
}
.change-btn {
  display: inline;
  position: absolute;
  top: 0;
  right: 0;
  margin: 1em;
}
.m-b-100 {
  margin-bottom: 100px;
}
.hasChildrenUnder13-card {
  margin-top: 5px;
  border-radius: 10px;
}
.hasChildrenUnder13-small {
  padding: 12px;
}
.hasChildrenUnder13-card .card-body {
  padding: 0.25rem;
  border-radius: 10px;
}
.passed-away::after {
  content: ' (avliden)'
}
.text--relative::after {
  content: ' (inbjuden)'
}
.text-consent-choices {
  font-size: 0.57vw;
  margin-bottom: 5px;
  float: left;
  text-align: left;
}
.text--consent--choices {
  font-size: 0.6vw;
  margin-bottom: 5px;
  float: left;
  text-align: left;
}
.modal-footer, .modal-header  {
  border: 0;
}
.w-break {
  word-break: break-word;
}
/* Portrait and Landscape */
@media only screen
  and (min-device-width: 300px)
  and (max-device-width: 812px) {
    .welcome-header-h4 {
      display: block;
      font-size: 16px;
    }
    .m-b-100 {
      margin-bottom: 30px !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/FamilyTree.vue